import { motion, useScroll, useTransform } from 'framer-motion'
import { useRef } from 'react'

interface ParallaxImageProps {
  src: string
  alt: string
  className?: string
  speed?: number
  overlay?: boolean
  overlayOpacity?: number
}

export function ParallaxImage({
  src,
  alt,
  className = '',
  speed = 0.3,
  overlay = false,
  overlayOpacity = 0.4,
}: ParallaxImageProps) {
  const ref = useRef<HTMLDivElement>(null)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  })

  const y = useTransform(scrollYProgress, [0, 1], [`-${speed * 100}%`, `${speed * 100}%`])

  return (
    <div ref={ref} className={`relative overflow-hidden ${className}`}>
      <motion.div style={{ y }} className="absolute inset-[-20%]">
        <img
          src={src}
          alt={alt}
          className="absolute inset-0 h-full w-full object-cover"
          loading="lazy"
        />
      </motion.div>
      {overlay && (
        <div
          className="absolute inset-0 bg-wood-dark"
          style={{ opacity: overlayOpacity }}
        />
      )}
    </div>
  )
}
